<template>
    <div class="bannerBox" :height="bannerHeight">
        <el-carousel :height="bannerHeight">
        <el-carousel-item v-for="item in bannerArray" :key="item.id">
            <img width="100%" :src="baseUrl + item.image" @click="linkTo(item.url)"/>
        </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>

export default {
    props: {
        bannerArray: {
        type: Array, 
        default: () => [],
        required: true
        }
    },
    data() {
        return {
            baseUrl:window.config.apiUrl,
            bannerHeight:"1080px"
        }
    },
    methods: {
        linkTo(url){
            if(url==""){
                return
            }
            if(url[0] == '/'){
                url = '/#'+url;
            }
            window.open(url);
        },
        resetBannerControl(){
            let flag = setInterval(()=>{
                let controller = document.getElementsByClassName('el-carousel__button');
                if(controller.length > 0){
                    clearInterval(flag);
                    for(let i =0;i<controller.length;i++){
                        controller[i].style.background = '#5e8743';
                    }
                }                
            }, 100);         
        },
        fixBannerHeight(){
            if(this.$router.currentRoute.path == '/'){
                this.bannerHeight = "100vh";
            }
            else{
                this.bannerHeight = (100/2) + "vh";
            }
            //检测屏幕宽度
            if(this.$root.isMob){
                this.bannerHeight = "70vh";
            }
        }
    },
    mounted() {
        this.resetBannerControl();
        this.fixBannerHeight();
    }
}
</script>


<style lang="scss" src="@/assets/css/bannerIMG.scss" scoped></style>